import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {amCharts_v4_date_line_template} from "./amCharts_v4_date_line_template";

declare var ko: any;

export class articleAnalytics_template extends vnTemplate {

    protected analyticsTooltip: infoButton_template;
    protected analyticsTooltipContent;
    protected shortTermReportTooltip: infoButton_template;
    protected shortTermReportTooltipContent;
    protected copyLeaksResultsSectionTooltipContent;
    protected copyLeaksResultsSectionTooltip: infoButton_template;
    protected shortTermReportChart: amCharts_v4_date_line_template;

    protected buildViewModel(): any {
        let self = this;
        return {
            analytics: ko.observable([]),
            shortTermReport: ko.observable(null),
            isDatePublishAvailable: ko.observable(false),
            onNullText: ko.observable(),
            plagiarismStatus: ko.observable(null),
            plagiarismResults: ko.observableArray([]),
            numOfDays: ko.observable(null),
            minDate: ko.observable(null),
            maxDate: ko.observable(null),
            analyticsToolTip: ko.observable(null),
            shortTermReportTooltip: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(['article_edit_self', 'article_edit_brand', 'article_edit_publishingControl', 'article_edit_embargo'])),
            shortTermReportRange: ko.observable("day"),
            isOnWatchlist: ko.observable(false),
            watchlistButtonEnabled: ko.observable(false),
            lastRefreshedCounter: ko.observable(0),
            onClick7DayView: function (value, data,event){
                self.onClick7DayView();
            },
            onClick1DayView: function (value, data,event){
                self.onClick1DayView();
            },
            onClickRefresh: function (value, data,event){
                self.onClickRefresh();
            },
            onClickEditWatchlist: function (value, data, event){
                self.onClickEditWatchlist(value);
            }
        }
    }

    protected getTemplateHtml(): string {
        return `
            <div class="w-form-body performance">
                <div class="form-body full-width">
                    <strong class="form-sub-title ">Performance
                        <span class="w-tooltips-adv pos-top short"  style="display: inline-block;">
                            
                            ` + this.shortTermReportTooltip.getHtmlBuild() + `
                            
                    </strong>
                    <div class="w-justify" data-bind="visible: shortTermReport() != null && shortTermReport().length > 0">
                        <div class="sentinel-logo"></div>
                        <div class="w-left" style="margin-left: 2rem">
                            <div class="form-group row" style="margin: 0">
                                 <div class="form-check-inline width-auto">
                                    <input type="radio" name="ShortTermReportView" id="view_24hour" value="day" data-bind="checked: shortTermReportRange(), event: {change : onClick1DayView}"/>
                                    <label class="form-label" for="view_24hour">24 Hour View</label>
                                 </div>   
                                 <div class="form-check-inline width-auto">
                                     <input type="radio" name="ShortTermReportView" id="view_7day" value="week" data-bind="checked: shortTermReportRange(), event: {change : onClick7DayView}"/>
                                     <label  class="form-label" for="view_7day">7 Day View</label>   
                                 </div>
                            </div>
                        </div>
                        <div class="w-center">
                            <div id="legenddiv"></div>
                        </div>
                        <div class="w-right" style="margin-right: 2rem">
                            <button title="Add to Watchlist" type="button" data-bind="visible: !isOnWatchlist(), enable: watchlistButtonEnabled(), event: { click: onClickEditWatchlist.bind($data, true)}" class="btn icon only-icon i-watchlist" style="margin-right: 1rem"></button>
                            <button title="Remove from Watchlist" type="button" data-bind="visible: isOnWatchlist(), enable: watchlistButtonEnabled(), event: { click: onClickEditWatchlist.bind($data, false)}" class="btn icon only-icon i-watchlist-full" style="margin-right: 1rem"></button>
                            
                            <button type="button" data-bind="attr:{title: (lastRefreshedCounter() > 0 ? lastRefreshedCounter() + ' new datapoint(s) available' : 'Refresh')}, event: { click: onClickRefresh}" class="btn icon only-icon i-refresh" style="position: relative">
                                <span class="new-data-counter" data-bind="text: lastRefreshedCounter(), visible: lastRefreshedCounter() > 0"></span>
                            </button>
                        </div>
                    </div>
                    
                    <div class="form-group" style="min-height: 100px;" id="shortTermReportChart">
                        <div class="form-group" data-bind="visible: shortTermReport() != null && shortTermReport().length > 0">                        
                            ${this.shortTermReportChart.getHtmlBuild()}
                        </div>
                        <div class="form-group">
                            <p class="form-text"  data-bind="visible: shortTermReport() == null || shortTermReport().length < 1, text:'This article has not yet been published to the website. There is no performance data available for it.'"> </p>
                        </div>
                    </div>    
                </div>
            </div>
            
            <div class="w-form-body">
                <div class="form-body full-width">
                    <strong class="form-sub-title ">Top Keywords
                        <span class="w-tooltips-adv pos-top short"  style="display: inline-block;">
                            
                            ` + this.analyticsTooltip.getHtmlBuild() + `
                            
                    </strong>
                    <div class="form-group" data-bind="visible: analytics().length >0">
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>Keywords</span></th>
                                    <th><span>Total Clicks</span></th>
                                    <th><span>Total Impressions</span></th>
                                    <th><span>Average Position</span></th>
                                    <th><span>CTR</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: analytics" class="alternate">
                                
                                <tr data-bind="class: range">
                                    <td><span data-bind="text: query"></span></td>
                                    <td class="align-right"><span data-bind="text: totalClicks"></span></td>
                                    <td class="align-right"><span data-bind="text: totalImpressions"></span></td>
                                    <td class="align-right"><span data-bind="text: AveragePosition"></span></td>
                                    <td class="align-right"><span data-bind="text: CTR"></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div data-bind="visible: analytics().length <1" class="form-group">
                        <p class="form-text"  data-bind="text:onNullText"> </p>
                    </div>    
                </div>
            </div>
            <!-- .is-showing -->
            <div class="w-form-body analytics" data-bind="hidden : !permissions()['article_edit_publishingControl'].read">
                <div class="form-group" data-bind="visible : plagiarismStatus() == null" style="margin-top: 2rem">
                    <p>No Analytics Available</p>
                </div>
                    <div class="form-body full-width" data-bind="visible : plagiarismStatus() != null">
                    
                        <strong class="form-sub-title ">Copyleaks Results</strong>
                        <div class="w-tooltips-adv pos-top" style="position: absolute;top: 24px;right: 0;left: 160px;margin: auto;">
                                   ` + this.copyLeaksResultsSectionTooltip.getHtmlBuild() + `
                        </div> 
                        <div class="form-group">
                            <label for="" class="form-label" style="margin: 0 1rem .5rem;">Status</label>   
                            <p data-bind="text: plagiarismStatus() != null ? plagiarismStatus : 'No Analytics Available'" style="margin: 0 1rem 1rem;"></p>
                            <table class="list-action" data-bind="if: plagiarismResults().length != 0">
                                <thead>
                                    <tr>
                                        <th><span>Scan ID</span></th>
                                        <th><span>Identical Words</span></th>
                                        <th><span>Minor Changed Words</span></th>
                                        <th><span>Paraphrased Words</span></th>
                                        <th><span>Aggregated Score</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: plagiarismResults">
                                    <tr>
                                        <td><span data-bind="text: scanId"></span></td>
                                        <td><span data-bind="text: identicalWords"></span></td>
                                        <td><span data-bind="text: minorChangedWords"></span></td>
                                        <td><span data-bind="text: relatedMeaningWords"></span></td>
                                        <td data-bind="css:{'positive': aggregatedScore < 11, 'negative': aggregatedScore > 75, 'fair': aggregatedScore > 10 && aggregatedScore < 76}"><span data-bind="text: aggregatedScore"></span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "articlesAnalytics_template";
    }

    protected initPartial() {
        this.analyticsTooltip = new infoButton_template('analyticsTooltip', this.getTemplateViewModel(), this.caller)
        this.analyticsTooltip.setTitle('Analytics Overview');

        this.copyLeaksResultsSectionTooltip = new infoButton_template('copyLeaksResultsSectionTooltip', this.getTemplateViewModel(), this.caller)
        this.copyLeaksResultsSectionTooltip.setTitle('COPYLEAKS Results');
        this.copyLeaksResultsSectionTooltipContent = `
        <ul>
            <li>"Not Submitted" indicates an article will not be submitted for plagiarism detection.</li>
            <li>"Pending Submission" indicates an article will be submitted for plagiarism detection the first time it is "Scheduled" or "Published". It will also be submitted when there is a "Scheduled Republish" or it is "Republished".</li>
            <li>"Submitted" indicates an article has been submitted for plagiarism detection. Once a result is received, it will only be visible to users with the permission to publish or republish.</li>
        </ul>
        `
        this.copyLeaksResultsSectionTooltip.setContent(this.copyLeaksResultsSectionTooltipContent);

        this.shortTermReportTooltip = new infoButton_template('shortTermReportTooltip', this.getTemplateViewModel(), this.caller)
        this.shortTermReportTooltip.setTitle('Performance');
        this.shortTermReportTooltipContent = `<ul>
        <li>Views count each load of an article, including if it is loaded as part of the infinite scroll experience.</li>
        <li>Visits count each load of an article where a user navigated from an external source.</li>
        <li>Engagements indicates the percentage of users that navigated to a depth of at least 1600 pixels in the article.</li> </ul>`
        this.shortTermReportTooltip.setContent(this.shortTermReportTooltipContent);

        this.shortTermReportChart = new amCharts_v4_date_line_template("amCharts_v4_date_shortTermReport_line_template", this.getTemplateViewModel(), this.caller);
        this.shortTermReportChart.setXAxisRotation(-45);
        this.shortTermReportChart.setXAxisFontSize(14);
    }

    public setAnalytics(analytics: any) {
        // Set keyword list
        this.getTemplateViewModel().analytics(analytics);

        // numOfDays
        if(analytics !==null && analytics.length>0){
            this.setRange(analytics);
            this.setMaxDateMinDateNumOfDays(analytics);
        }else{
            let datePublish = this.caller.getDatePublished();

            if(datePublish !== null && datePublish !=="" ){
                this.getTemplateViewModel().onNullText("There is no Google Search Console query data available for any URL associated with this article’s history, in the last three months.  Google only makes available the top 25,000 query+URL results, based on clicks for each day.  There is no keyword result for this article that has surpassed the cutoff on any day")
            }else{
                this.getTemplateViewModel().onNullText("This article has not yet been published to the website.  There is no Google Search Console query data available for it.")
            }
            this.analyticsTooltipContent =  `<ul>
        <li>This data is based on the results that Google makes available for search keywords by page. Google only makes available the top 25,000 query+URL results, based on clicks for each day. This table has N/\A days of data between the dates of N/\A to N/\A. For each row, there is a colour indicating how reliable the results are:</li>
        <li>GREEN: If there are more than 70</li>
        <li>YELLOW: If there are between 30 to 70 (inclusive)</li>
        <li>RED: If there are less than 30</li> </ul>`;
            this.analyticsTooltip.setContent(this.analyticsTooltipContent);
        }
    }

    public setShortTermReport(shortTermReport): void {

        this.getTemplateViewModel().shortTermReport(shortTermReport["data"]);
        this.shortTermReportChart.setDate('date');
        this.shortTermReportChart.setMinGridDistance(20);

        if(this.getTemplateViewModel().shortTermReportRange() == "day"){

            this.shortTermReportChart.setInterval([
                {timeUnit: "minute", count: 5}
            ]);
        }else{

            this.shortTermReportChart.setInterval([
                {timeUnit: "hour", count: 1}
            ]);
        }

        // set y axis
        let yaxis = [];

        yaxis.push({
            field: "viewCount",
            name:  'Views',
            axis: "main",
            color: "#6e3dbb",
            opposite: false,
            bullet: "none"
        });

        yaxis.push({
            field: "visitCount",
            name:  'Visits',
            axis: "main",
            color: "#009888",
            opposite: false,
            bullet: "none"
        });

        yaxis.push({
            field: "depthMarkerCount",
            name:  'Engagements',
            axis: "main",
            color: "#268af9",
            opposite: false,
            bullet: "none",
            tooltipText: "{name}: [bold]{valueY} ({engagementRate}%)[/]",
            calculatePercent: true
        });

        this.shortTermReportChart.setYaxis(yaxis);

        let ranges = [];
        //Get publish dates
        let publishDate = shortTermReport["publishDate"];
        if(publishDate){

            ranges = [{
                publishDate: publishDate,
                publishType: "first"
            }];
            
            let republishes = shortTermReport["republishDates"];
            republishes.forEach(item=>{
                if(item.republishDate){
                    ranges.push({publishDate: item.republishDate, publishType: "republish"});
                }
            });
        }

        this.shortTermReportChart.setRanges(ranges);

        this.shortTermReportChart.drawChart(shortTermReport["data"]);

        this.shortTermReportChart.show();

        this.getTemplateViewModel().lastRefreshedCounter(0);
        let _this = this;
        clearInterval();
        setInterval(function() {
            let counter = _this.getTemplateViewModel().lastRefreshedCounter();
            if(!isNaN(counter)){

                counter++;
                _this.getTemplateViewModel().lastRefreshedCounter(counter);
            }
        }, 1000*60*5);

        this.setIsOnWatchlist(shortTermReport["isWatchlisted"]);
        this.getTemplateViewModel().watchlistButtonEnabled(true);
    }

    public setMaxDateMinDateNumOfDays(analytics){
        let maxNumOfDays = 0;
        if(analytics !==null && analytics.length>0){
            maxNumOfDays = (
                Math.max(...analytics.map(element => {
                        return element.numOfDays;
                    }),
                ));

            // let diff = Math.abs( maxDate- minDate);
            // numOfDays =(diff/(1000 * 3600 * 24));
        }
        if(maxNumOfDays ==0){
            maxNumOfDays = maxNumOfDays +1;
        }
        if(maxNumOfDays >90){
            maxNumOfDays = 90;
        }
        let curDate = this.formatDate(Date.now());
        const date = new Date();
        const subtractedDate = this.subtractDays(date, maxNumOfDays);
        let beginningDate = this.formatDate(subtractedDate);

        this.analyticsTooltipContent = `<ul>
        <li>This data is based on the results that Google makes available for search keywords by page. Google only makes available the top 25,000 query+URL results, based on clicks for each day. This table has `+maxNumOfDays+` days of data between the dates of `+beginningDate+` to `+curDate+`. For each row, there is a colour indicating how reliable the results are:</li>
        <li>GREEN: If there are more than 70</li>
        <li>YELLOW: If there are between 30 to 70 (inclusive)</li>
        <li>RED: If there are less than 30</li> </ul>`
        this.analyticsTooltip.setContent(this.analyticsTooltipContent);
    }

    public setRange(analytics: any){

        for(let a of analytics){
            if(a.numOfDays > 70){
                //rangeup
                a.range="positive";
            }else if(a.numOfDays >=30 && a.numOfDays <= 70){
                //rangeMid
                a.range="fair";

            }else{
                //rangelow
                a.range="negative";
            }
        }
        this.getTemplateViewModel().analytics([]);
        this.getTemplateViewModel().analytics(analytics);
    }

    public getAnalytics(){
        return this.getTemplateViewModel().analytics();
    }

    public setPlagiarismResults(plagiarismResults): void {

        this.getTemplateViewModel().plagiarismResults(plagiarismResults);
    }

    public setPlagiarismStatus(plagiarismStatus): void {

        //1: Not Submitted, 2: Pending Submission, 3: Submitted
        this.getTemplateViewModel().plagiarismStatus(plagiarismStatus);
    }

    public setPermissions(permissions): void {
        this.getTemplateViewModel().permissions(permissions);
    }

    public formatDate(milliseconds){
        const date = new Date(milliseconds);

        const utcDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));

        const year = utcDate.getUTCFullYear();
        const month = (utcDate.getUTCMonth() + 1 < 10 ? '0' : '') + (utcDate.getUTCMonth() + 1);
        const day = (utcDate.getUTCDate() < 10 ? '0' : '') + utcDate.getUTCDate();
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    public subtractDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() - days);
        return result;
    }

    public onClick7DayView(){

        this.getTemplateViewModel().shortTermReportRange("week");
        this.caller.getShortTermReport();
    }
    public onClick1DayView(){

        this.getTemplateViewModel().shortTermReportRange("day");
        this.caller.getShortTermReport();
    }
    public onClickRefresh(){

        this.caller.getShortTermReport();
    }

    public onClickEditWatchlist(isAddToWatchlist){
        this.getTemplateViewModel().watchlistButtonEnabled(false);
        this.caller.editWatchlist(isAddToWatchlist);
    }

    public setIsOnWatchlist(isOnWatchlist){
        this.getTemplateViewModel().isOnWatchlist(isOnWatchlist);
    }

    public setWatchlistButtonEnabled(watchlistButtonEnabled){
        this.getTemplateViewModel().watchlistButtonEnabled(watchlistButtonEnabled);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/articleAnalytics_template.ts